import React from "react"

/**
 * The faint blueprint behind the welcome band. Decorative only — pale teal
 * strokes at low opacity, pinned to the band's right half the way the
 * reference has it, and hidden from assistive technology.
 */
export const HomeWelcomeArt = () => (
  <svg
    aria-hidden
    focusable="false"
    viewBox="0 0 520 170"
    preserveAspectRatio="xMidYMid meet"
    style={{
      // Anchored to the band's right half at its own scale: stretched across
      // the full width the strokes blew up into furniture-sized boxes.
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      width: "min(680px, 62%)",
      height: "100%",
      pointerEvents: "none",
      opacity: 0.45
    }}
  >
    <g
      fill="none"
      stroke="#7FC4CC"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.55"
    >
      {/* Elevation of a gabled house */}
      <path d="M232 150V86l44-30 44 30v64" />
      <path d="M268 150v-34h16v34" />
      <path d="M244 100h14v14h-14zM294 100h14v14h-14z" />
      <path d="M222 90l54-37 54 37" />
      {/* Flat-roofed block beside it */}
      <path d="M330 150V74h62v76" />
      <path d="M330 92h62M330 112h62M330 132h62" />
      <path d="M348 74V62h26v12" />
      {/* Tower on the right */}
      <path d="M402 150V54h34v96" />
      <path d="M402 72h34M402 90h34M402 108h34M402 126h34" />
      <path d="M414 54V44h10v10" />
      {/* Ground line and dimension ticks */}
      <path d="M196 150h316" />
      <path d="M210 158v-8M250 158v-8M290 158v-8M330 158v-8M370 158v-8M410 158v-8M450 158v-8" />
    </g>
    <g fill="none" stroke="#9AD3D9" strokeWidth="1" opacity="0.35">
      <path d="M452 150V96h40v54M452 112h40M452 130h40" />
      <circle cx="214" cy="68" r="12" />
      <path d="M470 60h30M485 45v30" />
    </g>
  </svg>
)
